// ----------------------------------------------------------------------
// <copyright file="Izenda.AdditionalItems.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * AdditionalItems component
 */
!(function() {

  var React = require('react');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var Panel = require('share/components/controls/Izenda.Panel');
  var Label = require('share/components/controls/Izenda.Label');
  var Source = require('./Izenda.Source');
  var Destination = require('./Izenda.Destination');
  var ItemsToCopy = require('./Izenda.ItemsToCopy');
  var connect = require('share/enhancers/Izenda.Connect');
  var observer = require('mobx-react').observer;

  var AdditionalItems = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      item: React.PropTypes.object.isRequired,
      disabled: React.PropTypes.bool
    },

    render: function() {
      var store = this.props.store;
      var item = this.props.item;
      var localization = this.props.localization;

      return (
        <Panel>
          <GridLayout>
            <GridLayout.Row className='u_table u_fullWidth u_noMarginAll'>
              <GridLayout.Col cols={6} className='u_tableCell u_alignMiddle u_floatNone u_noPaddingLeft'>
                <Source
                  store={this.props.store}
                  title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SOURCE')}
                />
              </GridLayout.Col>
              <GridLayout.Col cols={6} className='u_tableCell u_alignMiddle u_floatNone'>
                <Destination
                  store={this.props.store}
                  title={localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_DESTINATIONS')}
                />
              </GridLayout.Col>
            </GridLayout.Row>
            <GridLayout.Row>
              <GridLayout.Col cols={12}>
                <div className='separator' />
              </GridLayout.Col>
            </GridLayout.Row>
          </GridLayout>
          <ItemsToCopy item={item} disabled={this.props.disabled} store={store} />
        </Panel>
      );
    }
  });

  module.exports = observer(connect()(AdditionalItems));
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/AdditionalItems/Izenda.AdditionalItems.jsx